<template>
  <main class="container-fluid">
    <div class="row pb-1">
      <div
        class="text-right col-12 my-1"
      >
      <locale />
      </div>
    </div>
    <!--  -->
    <div class="row">
      <div class="col-12 text-center">
        <b-link :to="{name:'auth-login'}">
          <img class="img_logo mb-2" :src="logo" alt="logo">
        </b-link>
      </div>
    </div>
    <!--  -->
    <div class="row justify-content-center align-items-center pt-1">
      <div class="col-lg-6 col-md-6 col-sm-12 order-2 order-md-1">
        <img class="img-fluid reset_pass_img" :src="sideImg" alt="reset password photo">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 order-1 order-md-2">
        <div class="row">
          <div class="col-12">
            <!-- Reset Password v1 -->
            <b-card class="mb-0">

              <b-card-title class="mb-1">
                {{$t('message.reset_password')}} 🔒
              </b-card-title>
              <b-card-text class="mb-2">
                {{$t('message.reset_password_label')}}
              </b-card-text>

              <!-- form -->
              <validation-observer ref="simpleRules">
                <b-form
                  method="POST"
                  class="auth-reset-password-form mt-2"
                  @submit.prevent="validationForm"
                >

                  <!-- password -->
                  <b-form-group
                    :label='$t(`message.new_pass`)'
                    label-for="reset-password-new"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Password"
                      vid="Password"
                      rules="required|password"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid':null"
                      >
                        <b-form-input
                          id="reset-password-new"
                          v-model="password"
                          :type="password1FieldType"
                          :state="errors.length > 0 ? false:null"
                          class="form-control-merge"
                          name="reset-password-new"
                          placeholder="············"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="password1ToggleIcon"
                            @click="togglePassword1Visibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- confirm password -->
                  <b-form-group
                    label-for="reset-password-confirm"
                    :label='$t(`message.confirm_password`)'
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Confirm Password"
                      rules="required|confirmed:Password"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid':null"
                      >
                        <b-form-input
                          id="reset-password-confirm"
                          v-model="cPassword"
                          :type="password2FieldType"
                          class="form-control-merge"
                          :state="errors.length > 0 ? false:null"
                          name="reset-password-confirm"
                          placeholder="············"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="password2ToggleIcon"
                            @click="togglePassword2Visibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- submit button -->
                  <b-button
                    block
                    type="submit"
                    variant="primary"
                  >
                    {{$t('message.set_new_password')}}
                  </b-button>
                </b-form>
              </validation-observer>

              <p class="text-center mt-2 font-weight-bold">
                <b-link :to="{name:'auth-login'}">
                  <feather-icon icon="ChevronLeftIcon" /> {{$t('message.back_login')}}
                </b-link>
              </p>

            </b-card>
          <!-- /Reset Password v1 -->
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Locale from '../components/Locale.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Locale
  },
  data() {
    return {
      key:null,
      logo: require('@/assets/images/quotation/sft_logo.svg'),
      sideImg: require('@/assets/images/pages/reset-password-v2-dark.svg'),
      userEmail: '',
      cPassword: '',
      password: '',
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    toast(msg,variantMsg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'EditIcon',
          variant: variantMsg,
        },
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const data = {
            token:'1dbaa403b94ccdd1991c3afd511858a5',
            resetToken:this.key,
            password: this.password
          }
          const url= {
            prod: 'https://api-quote.safetravel.today/v2/app/set_new_password'
          };
          fetch(url.prod, {
              method: 'post',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data)
          })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP set new password error: HTTP ${response.status}`)
            return response.json()
          })
          .then((res)=> {
            if (res) {
              if (res === 'not_valid') {
                this.toast('There was a problem updating your password. Please try again.','danger');
              } else if(res==='password_already_changed') {
                this.toast('Your password has recently been changed. You will have to wait until the previous link expires before you can reset your password again.','success');
                setTimeout(()=> window.location.href = '/login',6500);
              } else if (res==='password_changed') {
                this.toast('Your password has been changed.','success');
                setTimeout(()=> window.location.href = '/login',3500);
              }
            }
          })
          .catch(error => {
            console.warn('There was an error changing password', error)
          })
        }
      })
    }
  },
  created() {
    const key = new URL(location.href).searchParams?.get('key') ?? null;
    if (!key) {
      window.location.href = '/login';
    } else {
      this.key=key;
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.img_logo {
  display: inline-block;
  margin: 0 auto;
  max-width: 650px;
  width: 80%;
  height: auto;
}
@media (max-width: 768px) {
  .reset_pass_img {
    max-width: 80%;
    display: block;
    margin: 10px auto;
  }
}
</style>
